import {
  Toolbar,
  ToolbarButton,
  FluentProvider,
  webLightTheme,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { EditRegular, TimelineRegular, DeleteRegular } from '@fluentui/react-icons';
import React from 'react';

interface IProcessTemplateDetailsCommandProps {
  onEditProcessTemplateClick: () => void;
  onManageMilestoneClick: () => void;
  onDeactivateProcessTemplateClick: () => void;

  disableCommandButtons: boolean;
}

const useStyles = makeStyles({
  toolbar: {
    padding: '0px',
    margin: '-30px -30px 0 -30px',
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  toolbarButton: {
    fontWeight: 'normal',
    padding: '0 10px',
    minHeight: '44px',
    fontSize: '14px',
  },
  iconBlue: {
    color: tokens.colorBrandForeground1,
    fontSize: '20px',
  },
});

const ProcessTemplateDetailsCommand = (props: IProcessTemplateDetailsCommandProps): JSX.Element => {
  const styles = useStyles();
  const {
    onEditProcessTemplateClick,
    onManageMilestoneClick,
    disableCommandButtons,
    onDeactivateProcessTemplateClick,
  } = props;

  return (
    <>
      <FluentProvider theme={webLightTheme}>
        <Toolbar
          className={styles.toolbar}
          aria-label="Use left and right arrow keys to navigate between commands"
        >
          <ToolbarButton
            icon={<EditRegular />}
            onClick={onEditProcessTemplateClick}
            disabled={disableCommandButtons}
            appearance="subtle"
            className={styles.toolbarButton}
          >
            Edit Name & Description
          </ToolbarButton>
          <ToolbarButton
            icon={<TimelineRegular />}
            onClick={onManageMilestoneClick}
            disabled={disableCommandButtons}
            appearance="subtle"
            className={styles.toolbarButton}
          >
            Manage Current Milestones
          </ToolbarButton>
          <ToolbarButton
            icon={<DeleteRegular />}
            onClick={onDeactivateProcessTemplateClick}
            disabled={disableCommandButtons}
            appearance="subtle"
            className={styles.toolbarButton}
          >
            Deactivate Process Template
          </ToolbarButton>
        </Toolbar>
      </FluentProvider>
    </>
  );
};
export default ProcessTemplateDetailsCommand;
